import { ref } from 'vue'

const message = ref('')
const politeness = ref<'polite' | 'assertive'>('polite')

/**
 * Composable for announcing dynamic content changes to screen readers.
 * Uses ARIA live regions to notify users of updates that occur outside
 * their current focus area.
 *
 * - Use 'polite' (default) for non-urgent updates (success messages, result counts)
 * - Use 'assertive' for urgent updates (errors, required actions)
 *
 * The live region must be rendered in App.vue for announcements to work.
 */
export function useAnnouncer() {
  function announce(text: string, type: 'polite' | 'assertive' = 'polite') {
    // Clear the message first to ensure screen readers pick up repeated announcements
    message.value = ''
    politeness.value = type
    // Small delay to ensure screen readers pick up the change
    setTimeout(() => {
      message.value = text
    }, 100)
  }

  function clear() {
    message.value = ''
  }

  return { message, politeness, announce, clear }
}
